import type { WebModule } from "../../core/modules";
import { AgendaPage } from "./routes/agenda";
import { TravauxPage } from "./routes/travaux";
import { TravailPage } from "./routes/travail";
import { ClientsPage } from "./routes/clients";
import { ClientPage } from "./routes/client";
import { CataloguePage } from "./routes/catalogue";
import { EquipePage } from "./routes/equipe";
import { ProduitsPage } from "./routes/produits";
import { FacturesPage } from "./routes/factures";
import { TaxesPage } from "./routes/taxes";
import { AtelierTopbar } from "./components/atelier-topbar";
import { InvoicesWidget } from "./components/invoices-widget";
import { TodayWidget } from "./components/today-widget";
import { WeekWidget } from "./components/week-widget";

// Atelier PROTECTO : agenda par technicien, travaux, clients et véhicules,
// catalogue de services, équipe (admin), deux widgets d'accueil et la barre
// du haut (recherche + nouveau rendez-vous) — voir docs/ATELIER-API.md,
// section « Écrans web ».
const atelier: WebModule = {
  name: "x-atelier",
  routes: [
    { path: "/agenda", element: <AgendaPage /> },
    { path: "/travaux", element: <TravauxPage /> },
    { path: "/travaux/:id", element: <TravailPage /> },
    { path: "/clients", element: <ClientsPage /> },
    { path: "/clients/:id", element: <ClientPage /> },
    { path: "/factures", element: <FacturesPage /> },
    { path: "/factures/taxes", element: <TaxesPage /> },
    { path: "/catalogue", element: <CataloguePage /> },
    { path: "/equipe", element: <EquipePage />, adminOnly: true },
    { path: "/produits", element: <ProduitsPage />, adminOnly: true },
  ],
  nav: [
    {
      title: "Atelier",
      // Le métier de tous les jours passe devant les modules du modèle (CRM, guides).
      order: 10,
      items: [
        { to: "/agenda", label: "Agenda", icon: "calendar", end: true },
        { to: "/travaux", label: "Travaux", icon: "checklist" },
        { to: "/clients", label: "Clients", icon: "users" },
        { to: "/factures", label: "Factures", icon: "dollar" },
        { to: "/catalogue", label: "Catalogue", icon: "list", end: true },
        { to: "/equipe", label: "Équipe", icon: "user", end: true, adminOnly: true },
        { to: "/produits", label: "Produits", icon: "coins", end: true, adminOnly: true },
      ],
    },
  ],
  homeWidgets: [
    { id: "atelier-today", element: <TodayWidget />, size: "wide" },
    { id: "atelier-week", element: <WeekWidget /> },
    { id: "atelier-invoices", element: <InvoicesWidget /> },
  ],
  topbar: <AtelierTopbar />,
};

export default atelier;
